// updateApartment.ts
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import type { Apartment } from '../CommonTypes';

export type UpdateApartmentInput = {
  company: string; // e.g. site.company
  site: string; // e.g. site.siteid
  id: string; // Firestore document id for the apartment
  data: Partial<Pick<Apartment, 'status'>>; // Partial apartment data
};

const updateApartment = async ({ company, site, id, data }: UpdateApartmentInput) => {
  const ref = doc(db, `${company}/${site}/apartments/${id}`);
  await setDoc(ref, data, { merge: true });
  return { id, data };
};

export default updateApartment;
